class OptimumidsController {
  constructor($state,$window,$rootScope,storage,laboxSSapi, analyticsService) {
    this.name = 'Optimum IDs';
    this.$state = $state;
    this.$rootScope = $rootScope;
	this.optimumidsLoader = true;
	this.hasOptimumID = storage.getItem('session', 'hasOptimumId')?true:false;
	this.totalOptIdCount = (storage.getItem('session', 'maxIdAvailable'));
	this.errorWhileLoading = false;
	this.primaryIndex = 0;
	this.primaryObj = null;


    this.keyWatch = event => {
      	window.addEventListener('keydown', this.keydown,false);
    };

    this.keydown = (event)=> {
      event.stopPropagation();
      if(event.keyCode === 27 || event.keyCode === 8 || event.keyCode ===461){
          window.removeEventListener('keydown', this.keydown);
          this.$rootScope.fromOptimumIdPage = true;
          this.$state.go('home.landingpage');
      }
    };

	laboxSSapi.getAllOptimumIds().then((res) => {
	    if(res && res.data && res.data.status === 'Success'){
        // omniture when IDs load successfully
        console.log('!!omniture when IDs load successfully!!');
        analyticsService.sendReport('optimum ids', 'ids', 'event1', null, null, null, null, null,
          this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);

	    	/*console.log("result from optimum ids:", res.data);
	        var optids = [{
	            optimumid: "159755",
	            firstName: "QA",
	            lastName: "Test",
	            primary: "true"
	        }, {
	            optimumid: "159751",
	            firstName: "QA",
	            lastName: "Test",
	            primary: "false"
	        }, {
	            optimumid: "testoptsecid",
	            firstName: "optid",
	            lastName: "sec",
	            primary: "false"
	        }, {
	            optimumid: "lauren2733",
	            firstName: "Lauren",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "millie9755",
	            firstName: "Millie",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "allison2733",
	            firstName: "Allison",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "corptesting80",
	            firstName: "Corptesting80",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "159756",
	            firstName: "QA",
	            lastName: "Test",
	            primary: "false"
	        }, {
	            optimumid: "159752",
	            firstName: "QA",
	            lastName: "Test",
	            primary: "false"
	        }, {
	            optimumid: "testsecid",
	            firstName: "test",
	            lastName: "secid",
	            primary: "false"
	        }, {
	            optimumid: "nancy2733",
	            firstName: "Nancy",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "aubrey2733",
	            firstName: "Aubrey",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "ramtest5090",
	            firstName: "biu",
	            lastName: "test",
	            primary: "false"
	        }, {
	            optimumid: "corptesting79",
	            firstName: "Corptesting79",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "159755",
	            firstName: "QA",
	            lastName: "Test",
	            primary: "true"
	        }, {
	            optimumid: "159751",
	            firstName: "QA",
	            lastName: "Test",
	            primary: "false"
	        }, {
	            optimumid: "testoptsecid",
	            firstName: "optid",
	            lastName: "sec",
	            primary: "false"
	        }, {
	            optimumid: "lauren2733",
	            firstName: "Lauren",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "millie9755",
	            firstName: "Millie",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "allison2733",
	            firstName: "Allison",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "corptesting80",
	            firstName: "Corptesting80",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "159756",
	            firstName: "QA",
	            lastName: "Test",
	            primary: "false"
	        }, {
	            optimumid: "159752",
	            firstName: "QA",
	            lastName: "Test",
	            primary: "false"
	        }, {
	            optimumid: "testsecid",
	            firstName: "test",
	            lastName: "secid",
	            primary: "false"
	        }, {
	            optimumid: "nancy2733",
	            firstName: "Nancy",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "aubrey2733",
	            firstName: "Aubrey",
	            lastName: "EmailMigration",
	            primary: "false"
	        }, {
	            optimumid: "ramtest5090",
	            firstName: "biu",
	            lastName: "test",
	            primary: "false"
	        }, {
	            optimumid: "corptesting79",
	            firstName: "Corptesting79",
	            lastName: "EmailMigration",
	            primary: "false"
	        }];*/

	        this.items = res.data.optimumIdInfo.map(item => {
	        //this.items = optids.map(item => {
              return {
              	  isPrimary: item.userIDType,
                  label: item.loginID,
                  data: item.firstName + ' ' + item.lastName
              };
	        });
        	for ( var i = 0; i < this.items.length; i++) {
        		if (this.items[i].isPrimary === "true"){
     				console.log("i is " + i);
        			this.primaryIndex = i;
        		}
        		console.log("there is no primary id");
        	}
	        console.log("this.primaryIndex is " + this.primaryIndex);
	        this.primaryObj = this.items[this.primaryIndex];
	        this.items[this.primaryIndex] = this.items[0];
	        this.items[0] = this.primaryObj;

	        this.currentOptIdCount = (storage.getItem('session', 'optimum_ids')).length;
	        this.itemsLength = this.currentOptIdCount;
	        if (this.itemsLength != null && this.itemsLength > this.totalOptIdCount){
	        	this.totalOptIdCount = this.itemsLength;
	        }
	        this.optPrimary = storage.getItem('session', 'primary_id');
	        this.hasOptimumID = true;
	        this.optimumidsLoader = false;
	        setTimeout(function() {
                document.getElementById('next-btn').focus();
            }, 100);
	    }
	    else if(res && res.data && res.data.status === 'FAILURE'){
        // omniture when IDs with API error
        console.log('!!omniture when IDs with API error!!');
        analyticsService.sendReport('optimum ids', 'optimum ids', 'event1', 'api error', null, null, null, null,
          this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill);

	      this.hasOptimumID = false;
	      this.optimumidsLoader = false;
	    }
	    else{
	      this.errorWhileLoading = true;
	      this.optimumidsLoader = false;
	    }
	});

  }
}

OptimumidsController.$inject = ['$state','$window','$rootScope','storage','laboxSSapi', 'analyticsService'];

export default OptimumidsController;



// WEBPACK FOOTER //
// ./client/app/components/optimumids/optimumids.controller.js